import type { FC } from 'react';
import type { GetStaticPaths } from 'next';
import { createPagePropsHandler } from '@/util/server/page-props';
import { enumerateStaticPaths } from '@/util/server/static-paths';
import { pageNameToJSX } from '@/components/pages';
import type { PageProps } from '@/types';

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: await enumerateStaticPaths('en', 'p2'),
  fallback: false,
});

export const getStaticProps = createPagePropsHandler('en', 'p2');

const P2: FC<PageProps> = (props) => {
  return pageNameToJSX(props.meta.componentName, props);
};

export default P2;
